export const WARDS_ERROR = '@api/WARDS_ERROR'
export const WARDS_REQUEST = '@api/WARDS_REQUEST'
export const WARDS_SUCCESS = '@api/WARDS_SUCCESS'

export const WARDS_CLEAN_SUCCESS_REQUEST = '@api/WARDS_CLEAN_SUCCESS_REQUEST'
export const WARDS_CLEAN_ERROR_REQUEST = '@api/WARDS_CLEAN_ERROR_REQUEST'
